<template>
  <div>
    <a :href="storeLink" :alt="altText">
      <img :src="imageLocation" :alt="altText" style="width: 120px; height: 36px;" />
    </a>
  </div>
</template>

<script>
import { DOWNLOAD_APPLE_STORE, DOWNLOAD_PLAY_STORE } from '../utils/translations';

import { APP_STORE_LINK, GOOGLE_PLAY_LINK, APP_GALLERY_LINK } from '../utils/links';

export default {
  props: {
    lang: {
      type: String,
      default: 'EN',
    },
    os: {
      type: String,
      default: 'android',
    },
  },
  computed: {
    altText() {
      if (this.os === 'ios') return DOWNLOAD_APPLE_STORE[this.lang];
      else return DOWNLOAD_PLAY_STORE[this.lang];
    },
    imageLocation() {
      // eslint-disable-next-line
      if (this.os === 'ios') {
        return require(`../assets/img/download-on-app-store-${this.lang.toLowerCase()}.svg`);
      } else if (this.os === 'huawei') {
        return require(`../assets/img/download-on-app-gallery@3x.png`);
      }
      return require('../assets/img/download-on-google-play-en.svg');
    },
    storeLink() {
      if (this.os === 'ios') {
        return APP_STORE_LINK;
      } else if (this.os === 'huawei') {
        return APP_GALLERY_LINK;
      }
      return GOOGLE_PLAY_LINK;
    },
  },
};
</script>
